module.exports = __webpack_public_path__ + "img/alarm_marker.8f216257.svg";